import ProductDescription from './ProductDescription'

const CheeseProduct = {
  ...ProductDescription,
  category: '02',
  subCategory: '001',
  IsBroadband: false,
  FatLevel: '',
  Type: '',
  Size: '',
  MadeInUSA: false,
  Kosher: false,
}

export default CheeseProduct
